import { Decoration, DecorationSet, isEmptyDoc } from '@tencent/exeditor3-core';
const defaultOption = {
    content: '请输入内容',
};
const styles = `
.exeditor-placeholder-container {
  position: absolute;
  white-space: nowrap;
  text-indent: 0;
  color: #aaa;
  cursor: text;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
}

[style*="text-align:right"i] > .exeditor-placeholder-container,
[style*="text-align: right"i] > .exeditor-placeholder-container {
  transform: translateX(-100%);
}
`;
export class PlaceholderPlugin {
    constructor(opt = defaultOption) {
        this.opt = opt;
        this.name = 'placeholder';
    }
    initEditor() { }
    capabilities() {
        return {
            decorate: (doc, docChanged) => {
                if (docChanged === false) {
                    return false;
                }
                return this.createDecorations(doc);
            },
            styles,
        };
    }
    createDecorations(doc) {
        const decos = [];
        if (isEmptyDoc(doc)) {
            decos.push(Decoration.widget(1, () => {
                const { content } = this.opt;
                const container = document.createElement('span');
                container.className = 'exeditor-placeholder-container';
                container.appendChild(typeof content === 'string'
                    ? document.createTextNode(content)
                    : content);
                return container;
            }));
        }
        return DecorationSet.create(doc, decos);
    }
}
//# sourceMappingURL=index.js.map